<a [href]="appStoreUrl" target="_blank">
  <img src="../../../../../assets/images/apple-app.svg" class="h-12" alt="Get it on the App Store"/>
</a>
